// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3zGSc","cell":"ColumnAccessor_cell__1Tgik","firstCellAccent":"ColumnAccessor_firstCellAccent__3HS_7"};